import { useState, useEffect } from "react";
import axios from "axios";
import useAuth from "../../auth/hooks/useAuth";

//expects params game_type and topics
const useTopicQuestions = params => {
  const [loadedquestions, setQuestions] = useState();
  const [status, setStatus] = useState();
  //const { state: authState } = useAuth();

  useEffect(() => {
    try {
      (async () => {
        setStatus("LOADING");

        const response = await axios({
          method: "get",
          url: `${process.env.REACT_APP_OAUTH_URL}/lite/topics/questions`,
          params
        });
        setQuestions(response.data);
        setStatus("OK");
        console.log(response);
      })();
    } catch (e) {
      setStatus("ERROR");
    }
  }, []);

  return {
    loadedquestions,
    status
  };
};

export default useTopicQuestions;
